/* eslint-disable no-undef */

import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import CardComponent from "../../components/cards/CardComponent";
import InventorySubmenu from "../../components/submenu_components/inventorySubmenu";

import Header from "../../components/Header";
import Layout from "../../layout/Layout";

export default function TableList() {
  return (
    <>
      <Layout>
        <Header title="Inventory Management" />
        <ToastContainer />
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <CardComponent
              title="Inventory Management System"
              headerColor="primary"
              pull="left"
              bodyClass="panel-body"
              headerContent={
                <div className="d-flex align-items-center">
                  <i className="zmdi zmdi-store me-2"></i>
                  <span>Quick Actions & Management</span>
                </div>
              }
            >
              <InventorySubmenu />
            </CardComponent>
          </div>
        </div>
      </Layout>
    </>
  );
}
